import { useState, useCallback } from 'react';
import { RegiaoVendasDrillDownData, RegiaoVendasData } from '../types/regiaoVendasDrillDown';

export const useRegiaoVendasDrillDown = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRegiao, setSelectedRegiao] = useState<RegiaoVendasData | null>(null);
  const [drillDownData, setDrillDownData] = useState<RegiaoVendasDrillDownData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const openModal = useCallback(async (regiaoData: RegiaoVendasData, spedFiscalId: number) => {
    if (!spedFiscalId) {
      setError('ID do SPED Fiscal não fornecido.');
      setSelectedRegiao(null);
      setIsModalOpen(false);
      setLoading(false);
      return;
    }
    
    setSelectedRegiao(regiaoData);
    setIsModalOpen(true);
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}sped-fiscal/regiao-vendas-drill-down/${spedFiscalId}/${regiaoData.nome}`);
      if (!response.ok) {
        throw new Error(`Erro na API: ${response.statusText}`);
      }
      const data: RegiaoVendasDrillDownData = await response.json();
      setDrillDownData(data);
    } catch (err: any) {
      setError(err.message || 'Falha ao buscar dados de drill down.');
    } finally {
      setLoading(false);
    }
  }, []);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    setSelectedRegiao(null);
    setDrillDownData(null);
  }, []);

  const retry = useCallback(() => {
    if (selectedRegiao && selectedRegiao.spedFiscalId) {
      openModal(selectedRegiao, selectedRegiao.spedFiscalId);
    }
  }, [selectedRegiao, openModal]);

  return {
    isModalOpen,
    selectedRegiao,
    drillDownData,
    loading,
    error,
    openModal,
    closeModal,
    retry,
  };
};

declare module '../types/regiaoVendasDrillDown' {
    interface RegiaoVendasData {
        spedFiscalId?: number;
    }
} 